import Placeholder from './Placeholder';

export default Placeholder;
export * from './Placeholder';
